import { createSlice, Slice, SliceCaseReducers } from '@reduxjs/toolkit';
import { IListState } from './types';
import {
  RESPONSE_DEFAULT_ERROR,
  setFetchingError,
  setFetchingRequest,
  setFetchingSuccess,
} from '../helpers';
import { IDLE_STATUS } from '../../utils/types/statuses';

export const initialListState: IListState<any> = {
  status: IDLE_STATUS,
  error: { ...RESPONSE_DEFAULT_ERROR },
  data: [],
};

interface IGetListSlice<T> {
  moduleName: string;
  fetchDataThunk: any;
  initialState: IListState<T>;
  reducers?: SliceCaseReducers<IListState<T>>;
}

export function getListSlice<TData>({
  moduleName,
  fetchDataThunk,
  initialState,
  reducers = {},
}: IGetListSlice<TData>): Slice<IListState<TData>> {
  return createSlice({
    name: moduleName,
    initialState,
    reducers,
    extraReducers: (builder) => {
      builder
        .addCase(fetchDataThunk.pending, (state) => {
          setFetchingRequest(state);
        })
        .addCase(fetchDataThunk.fulfilled, (state, action) => {
          setFetchingSuccess(state);
          state.data = action.payload;
        })
        .addCase(fetchDataThunk.rejected, (state, { payload }) => {
          setFetchingError(state, payload);
        });
    },
  });
}
